import { BUSCAR_OPCOES_FILTROS_CONFIGURACAO_BILHETE } from '../../actions/types'

const initialState = undefined;
const estadoInicial = {
    regras: [],
    orgaosReguladores: []    
}


export default function reducerBuscarOpcoesFiltrosConfiguracaoBilhete (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case BUSCAR_OPCOES_FILTROS_CONFIGURACAO_BILHETE: {
      const opcoesFiltros = action.payload.data;

      if (opcoesFiltros) {
        return opcoesFiltros
      }
      return estadoInicial
    }

    default: {
      return state
    }
  }
}
